import React, { Fragment, useContext } from "react";
import SystemContext from "../../../SystemContext";
import {useQueryClient} from "react-query";
import {Button, Icon, IconButton, Tooltip} from "@material-ui/core";
import { ActionButton } from "./controls";
import { useNotes } from "../../../services/notes";
import { useAuth0 } from "@auth0/auth0-react";
import {AddAlarm, AddAlarmTwoTone, AddBoxOutlined} from "@material-ui/icons";
import moment from "moment";
import __ from "lodash";
import { useComboValues } from "../../../services/settings";
import { AirplaneEventIcon, AirplaneNoteIcon, AirplaneDiversionIcon, AirplaneReturnIcon, GroundHandlerIcon } from "../../../icons";
import { LightTooltip } from "../..";
import ComboSelect from "../../ComboSelect";
import axios from "axios";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";

const AccessControl = require ("../../../AccessControl");
const apiSitePrefix = getApiSitePrefix();

const NotesScreen = (props) => {
  const {tripData, classes, eventBus} = props;
  const SystemData = useContext(SystemContext);
  const flightListMode = props.flightListMode || false;
  const displayOnly = props.displayOnly||false;
  const { user } = useAuth0();
  const canEdit = !displayOnly && AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS", "Manage TRIP NOTES"]);
  const canEditDelay = !displayOnly && AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS", "Manage TRIP DELAYS"]);

  const queryClient = useQueryClient();
  const noteType = "TRIP_LEG:FLIGHT";
  const eventNoteType = "TRIP_LEG:FLIGHT_EVENT";
  const cancelledEventNoteType = "TRIP_LEG:FLIGHT_EVENT_CANCELLED";
  const diversionNoteType = "TRIP_LEG:FLIGHT_DIVERSION";
  const possibleDiversionNoteType = "TRIP_LEG:FLIGHT_POSSIBLE_DIVERSION";
  const returnToStandNoteType = "TRIP_LEG:FLIGHT_RETURN_TO_STAND";
  const rampNoteType = "TRIP_LEG:FLIGHT_RAMP";
  const extraKeys = [tripData.uuid, encodeURIComponent('TRIP_LEG:FLIGHT%')];
  const notes = useNotes({queryClient, extraKeys});

  const cancelDelay = async (params) => {
    SystemData.confirm(
      params.title||"Apply Delay to Flight",
      "Are you sure you wish to cancel the delay?",
      params.activeDelay?[
        {icon: "restore", value: 'restore', label: "Reset ETD to STD", options: {color:"primary"}},
        {icon: "check_circle_outline", value: 'keep', label: "Keep current ETD", options: {color:"primary"}},
        {icon: "cancel", value: null, label: "No", options: {color:"secondary"}}
      ]: [
        {icon: "check_circle_outline", value: 'keep', label: "Yes", options: {color:"primary"}},
        {icon: "cancel", value: null, label: "No", options: {color:"secondary"}}
      ],
      async (response) => {
        if (response !== null) {
          try {
            SystemData.toggleLoadingProgress(true);
            const cancelled = await axios.put(`${apiSitePrefix}/notes/cancelDelay/${params.noteUuid}/${params.tripLegUuid}/${response}`);
            SystemData.toggleLoadingProgress(false);
            if (cancelled && cancelled.error) {
              SystemData.openAlert("Apply Failed", cancelled.errorMessage);
            }
          } catch(err) {
            SystemData.toggleLoadingProgress(false);
            SystemData.openAlert("Apply Failed", "An Unexpected error has occurred!");
          }
          queryClient.invalidateQueries(["Notes"]);
          eventBus.trigger('RouteView.refresh');
        }
      }
    );
  }

  const NoteHeader = (props) => {
    const className = (props.noteType===eventNoteType?"eventHeader":"noteHeader");
    return (
      <div className={classes[className]}>
        <div style={{display: "inline-block", textAlign: "left", width: 20}}>
          {
            props.noteType===eventNoteType?<AirplaneEventIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :props.noteType===cancelledEventNoteType?<AirplaneEventIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :props.noteType===diversionNoteType?<AirplaneDiversionIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :props.noteType===possibleDiversionNoteType?<AirplaneDiversionIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :props.noteType===returnToStandNoteType?<AirplaneReturnIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :props.noteType===rampNoteType?<GroundHandlerIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
            :<AirplaneNoteIcon style={{position:"relative", top: "2px"}} fontSize="inherit"/>
          }
        </div>
        <div style={{display: "inline-block", textAlign: "left", width: "50%"}}>{props.updatedAt}</div>
        <div style={{display: "inline-block", textAlign: "left", width: "calc(50% - 62px)"}}><Tooltip title={`${props.firstName} ${props.lastName}`}><div>{props.initials}</div></Tooltip></div>
        <div style={{display: "inline-block", textAlign: "right", width: 40}}>
          {((props.canEdit && props.noteType!==eventNoteType && props.noteType!==cancelledEventNoteType))?
            <IconButton
              style={{padding:2}}
              color="inherit"
              onClick={()=>{
                if (props.noteType===eventNoteType) {
                  const noteParams = {noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType: eventNoteType, title: `Flight Event for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
                  eventBus.trigger("TripLegEventDialog.open", noteParams);
                } else if (props.noteType===diversionNoteType) {
                  const noteParams = {noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType: diversionNoteType, title: `Flight Diversion for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
                  eventBus.trigger("TripLegDiversionDialog.open", noteParams);
                } else if (props.noteType===possibleDiversionNoteType) {
                  const noteParams = {noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType: possibleDiversionNoteType, title: `Possible Flight Diversion for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
                  eventBus.trigger("TripLegNoteDialog.open", noteParams);
                } else if (props.noteType===returnToStandNoteType) {
                  const noteParams = {noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType: returnToStandNoteType, title: `Flight Returned to Stand for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
                  eventBus.trigger("TripLegReturnToStandDialog.open", noteParams);
                } else if (props.noteType===rampNoteType) {
                  const noteParams = {noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType: rampNoteType, title: `Ramp Note for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
                  eventBus.trigger("TripLegNoteDialog.open", noteParams);
                } else {
                  eventBus.trigger("TripLegNoteDialog.open",{noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, noteType, title: `Flight Note for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
                }
              }}
            >
              <Icon color="inherit">edit</Icon>
            </IconButton>
          :null}
          {(props.canEditDelay && props.noteType===eventNoteType) ?
            <IconButton
              style={{padding:2}}
              color="inherit"
              onClick={()=>{
                cancelDelay({noteUuid: props.noteUuid, tripLegUuid: tripData.uuid, activeDelay: props.activeDelay, title: `Cancel delay for ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`})
              }}
            >
              <Icon color="inherit">cancel</Icon>
            </IconButton>
          :null}
        </div>
      </div>
    );
  }

  const DelayInfo = (props) => {
    return (
      <div className={classes.delay}>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "32px", paddingRight: 5}}>Code:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "30px"}}><LightTooltip title={props.delayData?.value||''}><span>{props.delayCode}</span></LightTooltip></div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "50px", paddingRight: 5}}>Duration:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "60px"}}>{props.delayOffsetFrom} + {props.delayMinutes}</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "25px", paddingRight: 5}}>Time:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "100px"}}>{moment.utc(props.delayedUntil).format('D MMM HH:mm')} {props.delayApplied?<AddAlarmTwoTone style={{position: "relative", top:2, fontSize: 14}}/>:null}</div>
      </div>
    );
  }

  const DiversionInfo = (props) => {
    return (
      <div className={classes.diversion}>
        <div style={{display: "block", textAlign: "left", minWidth: "50px", paddingRight: 5, fontSize: 14, fontWeight: "bold", paddingBottom: 3}}>Diverted to {props.divertedToAirport}</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "32px", paddingRight: 5}}>Planned Destination:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "50px"}}>{props.originalAirportCode}</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "25px", paddingRight: 5}}>Category:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "90px"}}>
          <ComboSelect
            displayOnly={true}
            group="FLIGHT DIVERSION"
            subGroup="CATEGORIES"
            value={props.diversionCategory}
          />
        </div>
      </div>
    );
  }

  const ReturnToStandInfo = (props) => {
    return (
      <div className={classes.diversion}>
        <div style={{display: "block", textAlign: "left", minWidth: "50px", paddingRight: 5, fontSize: 14, fontWeight: "bold", paddingBottom: 3}}>Returned to Stand</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "50px", paddingRight: 5}}>Blocks Off:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "90px"}}>{moment.utc(props.bloff).format('DD MMM HH:mm')}</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "50px", paddingRight: 5}}>Returned At:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "70px"}}>{moment.utc(props.returnedAt).format('DD MMM HH:mm')}</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "25px", paddingRight: 5}}>Category:</div>
        <div style={{display: "inline-block", textAlign: "left", minWidth: "100px"}}>
          <ComboSelect
            displayOnly={true}
            group="RETURN TO STAND"
            subGroup="CATEGORIES"
            value={props.category}
          />
        </div>
      </div>
    );
  }

  const Note = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      userInfo,
      updatedAt,
      canEdit
    } = props;

    const {firstName, lastName, initials, nickname} = {
      firstName:"",
      lastName:"",
      initials:"",
      nicename:'',
      ...userInfo
    }
    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          firstName={firstName}
          lastName={lastName}
          initials={initials}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          canEdit={canEdit}
          canEditDelay={canEditDelay}
        />
        <div className={classes.noteBody}>
          {noteText}
        </div>
      </>
    );
  }

  const Ramp = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      updatedAt,
      canEdit
    } = props;

    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          canEdit={canEdit}
        />
        <div className={classes.rampBody}>
          {noteText}
        </div>
      </>
    );
  }

  const Diversion = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      noteData,
      userInfo,
      updatedAt,
      canEdit
    } = props;

    const {firstName, lastName, initials, nickname} = {
      firstName:"",
      lastName:"",
      initials:"",
      nicename:'',
      ...userInfo
    }
    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          firstName={firstName}
          lastName={lastName}
          initials={initials}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          canEdit={canEdit}
          canEditDelay={canEditDelay}
        />
        <div className={classes.diversionBody}>
          <DiversionInfo
            originalAirportCode={noteData.destinationAirportCode}
            destinationAirportCode={noteData.destinationAirportCode}
            divertedToAirport={noteData.divertedToAirport}
            diversionCategory={noteData.diversionCategory}
          />
          {noteText}
        </div>
      </>
    );
  }

  const PossibleDiversion = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      noteData,
      userInfo,
      updatedAt,
      canEdit
    } = props;

    const {firstName, lastName, initials, nickname} = {
      firstName:"",
      lastName:"",
      initials:"",
      nicename:'',
      ...userInfo
    }
    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          firstName={firstName}
          lastName={lastName}
          initials={initials}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          canEdit={canEdit}
        />
        <div className={classes.diversionBody}>
          {noteText}
        </div>
      </>
    );
  }

  const ReturnToStand = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      noteData,
      userInfo,
      updatedAt,
      canEdit
    } = props;

    const {firstName, lastName, initials, nickname} = {
      firstName:"",
      lastName:"",
      initials:"",
      nicename:'',
      ...userInfo
    }
    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          firstName={firstName}
          lastName={lastName}
          initials={initials}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          canEdit={canEdit}
        />
        <div className={classes.returnToStandBody}>
          <ReturnToStandInfo
            bloff={noteData.bloff}
            returnedAt={noteData.returnTime}
            category={noteData.category}
          />
          {noteText}
        </div>
      </>
    );
  }

  const Event = (props) => {
    const {
      noteUuid,
      noteType,
      noteText,
      userInfo,
      delayRequired,
      delayCode,
      delayMinutes,
      delayApplied,
      delayOffsetFrom,
      delayedUntil,
      updatedAt,
      canEdit,
      activeDelay
    } = props;
    const {firstName, lastName, initials, nickname} = {
      firstName:"",
      lastName:"",
      initials:"",
      nicename:'',
      ...userInfo
    }
    const delayCombos = useComboValues({queryClient, extraKeys: ['DELAY CODES', '']});
    let delayData = {};
    if (delayCombos && Array.isArray(delayCombos.data)) {
      delayData = __.find(delayCombos.data, {code: delayCode})
    }
    const classNames = [classes.eventBody];
    if (delayApplied) {
      classNames.push(classes.delayApplied);
    }
    if (noteType === cancelledEventNoteType) {
      classNames.push(classes.cancelled);
    }

    return (
      <>
        <NoteHeader
          noteType={noteType}
          noteUuid={noteUuid}
          firstName={firstName}
          lastName={lastName}
          initials={initials}
          updatedAt={moment.utc(updatedAt).format('D MMM HH:mm')}
          delayRequired={true}
          delayMinutes={delayMinutes}
          delayedUntil={delayedUntil}
          delayCode={delayCode}
          delayData={delayData}
          canEdit={canEdit}
          canEditDelay={canEditDelay}
          activeDelay={activeDelay}
        />
        <div className={classNames.join(' ')}>
          <DelayInfo
            delayRequired={true}
            delayMinutes={delayMinutes}
            delayCode={delayCode}
            delayData={delayData}
            delayedUntil={delayedUntil}
            delayOffsetFrom={delayOffsetFrom}
            delayApplied={delayApplied}
          />
          {noteText}
        </div>
      </>
    );
  }

  const NoteAction = (props) => {
    const {
      flightListMode,
      variant,
      label,
      startIcon,
      onClick
    } = props;

    if (flightListMode) {
      return (
        <Button
          color="primary"
          variant="text"
          startIcon={<AddBoxOutlined/>}
          onClick={onClick}
        >
          {label}
        </Button>
      );
    }
    return (
      <ActionButton
        variant="outlined"
        startIcon={<Icon>add</Icon>}
        onClick={onClick}
      >
        {label}
      </ActionButton>
    );
  }

  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><Icon style={{position: "relative", top: 2}}>description</Icon></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Notes</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        {canEdit?
          <NoteAction
            flightListMode={flightListMode}
            label="Note"
            onClick={()=>{
              eventBus.trigger("TripLegNoteDialog.open",{tripLegUuid: tripData.uuid, noteType, title: `Flight Note for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
            }}
          />
        :null}
        {canEditDelay?
          <>
          <div style={{display: "inline-block", width: 5}}> </div>
          <NoteAction
            flightListMode={flightListMode}
            label="Delay"
            onClick={()=>{
              const noteParams = {tripLegUuid: tripData.uuid, noteType:eventNoteType, title: `Flight Delay for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUtc).format("D MMM HH:mm")}`, tripData};
              eventBus.trigger("TripLegEventDialog.open",noteParams);
            }}
          />
          </>
        :null}
      </div>
    </div>
    <div style={{width: "100%", display: "inline-block"}}>
      {(notes?.data||[]).map(note => (
        note.noteType===eventNoteType || note.noteType===cancelledEventNoteType?
        <Event
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          userInfo={note.updatedBy}
          delayRequired={true}
          delayCode={note.delayCode}
          delayMinutes={note.delayMinutes}
          delayApplied={note.delayApplied}
          delayedUntil={note.delayedUntil}
          delayOffsetFrom={note.delayOffsetFrom}
          updatedAt={note.updatedAt}
          canEdit={canEdit}
          canEditDelay={canEditDelay}
          activeDelay={note.activeDelay}
        />
      :
      note.noteType===diversionNoteType?
        <Diversion
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          userInfo={note.updatedBy}
        />
      :
      note.noteType===possibleDiversionNoteType?
        <PossibleDiversion
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          userInfo={note.updatedBy}
          updatedAt={note.updatedAt}
        />
      :
      note.noteType===returnToStandNoteType?
        <ReturnToStand
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          userInfo={note.updatedBy}
          updatedAt={note.updatedAt}
        />
      :
      note.noteType===rampNoteType?
        <Ramp
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          updatedAt={note.updatedAt}
        />
      :
        <Note
          noteUuid={note.noteUuid}
          noteType={note.noteType}
          noteText={note.noteText}
          noteData={note.noteData}
          userInfo={note.updatedBy}
          updatedAt={note.updatedAt}
          canEdit={canEdit}
          canEditDelay={canEditDelay}
        />
      ))}
    </div>

  </Fragment>);
}

export default NotesScreen;
